<script setup>
const props = defineProps({
    label: { type: [String, Number], required: true },
});
</script>

<template>
    <span class="uppercase text-sm tracking-widest">{{ props.label }}</span>
</template>
